<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="apocalypse">
<h1>Apocalypse?</h1>
<p style="text-align: center;"><em>What does the future hold for us,</em></p>
<p style="text-align: center;"><em>The world, and all that is to be?</em></p>
<p style="text-align: center;"><em>Impending doom, announced today,</em></p>
<p style="text-align: center;"><em>Is this what God would have us see?</em></p><br/>
<p style="text-align: center;"><em>I ponder on the claims His word</em></p>
<p style="text-align: center;"><em>Allows in terms of truth, of grace;</em></p>
<p style="text-align: center;"><em>How may discernment come? And what</em></p>
<p style="text-align: center;"><em>Will God reveal, today, of peace?</em></p><br/>
<p style="text-align: center;"><em>What can it mean, Apocalypse?</em></p>
<p style="text-align: center;"><em>This is a mystery, a drape</em></p>
<p style="text-align: center;"><em>Across the window of my mind;</em></p>
<p style="text-align: center;"><em>What could I see, of Heaven’s scape?</em></p><br/>
<p style="text-align: center;"><em>It is revealed! Apocalypse:</em></p>
<p style="text-align: center;"><em>The death of Death, the birth of Life!</em></p>
<p style="text-align: center;"><em>The curtain opens on Eternity;</em></p>
<p style="text-align: center;"><em>This ‘Day’ portrays an end to strife!</em></p><br/>
<p style="text-align: center;"><em>It is unveiled—the scope of life</em></p>
<p style="text-align: center;"><em>That’s in His plan: we’re Heaven bound!</em></p>
<p style="text-align: center;"><em>God’s word speaks Light and Life and Love.</em></p>
<p style="text-align: center;"><em>The Dawn has come: Redemption found.</em></p><br/>
<p style="text-align: center;">(LLT)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?3588480e